<em [class]="iconClass"></em>
